import React, { Component } from 'react'
import CategoryStore from 'stores/CategoryStore'
import Categories from 'components/Categories'
import IndexHeader from 'components/IndexHeader'
import Modes from 'components/Modes'
import ActionCreators from 'actions/ActionCreators'

import './CategoryScreen.scss'
import GeneralStore from '../../stores/GeneralStore'

function getStateFromStores() {
    return {
        isWidgetMode: GeneralStore.isWidgetMode(),
        isIsraelModeOn: GeneralStore.isIsraelModeOn(),
        categories: CategoryStore.getAllCategories(),
    };
}

/**
 * Экран списка категорий.
 */
class CategoryScreen extends Component {

    state = getStateFromStores();

    componentDidMount() {
        CategoryStore.addChangeListener(this._onChange)

        ActionCreators.deselectCategory(this.props.location.query)
        ActionCreators.setTotalMeasurements(0, 0, true)
    }

    componentWillUnmount() {
        CategoryStore.removeChangeListener(this._onChange);
    }

    _onChange = () => {
        this.setState(getStateFromStores());
    }

    render() {
        return (
            <div className="CategoryScreen">
                {!this.state.isWidgetMode ?
                    <IndexHeader /> : null}
                <header className="CategoryScreen-header">
                    <div className="CategoryScreen-title">
                        Что нужно перевезти?
                    </div>
                    <div className="CategoryScreen-subtitle">
                        Выберите категорию, к которой лучше всего подходит ваш груз
                    </div>
                    <div className="CategoryScreen-subtitleMobile">
                        Выберите категорию перевозки
                    </div>
                </header>
                <Categories categories={this.state.categories} />
                {!this.state.isWidgetMode && !this.state.isIsraelModeOn ?
                    <Modes/> : null}
            </div>
        );
    }

}

export default CategoryScreen;



// WEBPACK FOOTER //
// ./client/components/CategoryScreen/CategoryScreen.js